import type { JsonValue, UserSettings } from '../../types/settings';
import { apiFetch, apiRequest } from './client';

export function fetchUserSettings(): Promise<UserSettings> {
  return apiFetch<UserSettings>('/api/user-settings');
}

export function saveUserSetting(key: string, value: JsonValue): Promise<void> {
  return apiRequest(`/api/user-settings/${encodeURIComponent(key)}` as `/api/${string}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}
